import { MONEY_DECIMALS, roundMoney } from '../../../../../utils/money';
import { splitMoney } from 'shared-models/browser';
export const clampToMoney = (value: number, roundAmounts = MONEY_DECIMALS === 0): number => roundMoney(value, roundAmounts);

export const computeEqualSplitAmounts = (totalAmount: number, count: number, roundAmounts = MONEY_DECIMALS === 0): number[] => {
  if (roundAmounts) return splitMoney(totalAmount, count, true);
  if (count <= 0) {
    return [];
  }
  const totalTenths = Math.round(totalAmount * 10);
  const baseTenths = Math.floor(totalTenths / count);
  const remainderTenths = totalTenths - baseTenths * count;
  return Array.from({ length: count }, (_, index) =>
    Number(((baseTenths + (index < remainderTenths ? 1 : 0)) / 10).toFixed(1)),
  );
};

export const computeEqualSplitAmount = (totalAmount: number, count: number, roundAmounts = MONEY_DECIMALS === 0): number => {
  const amounts = computeEqualSplitAmounts(totalAmount, count, roundAmounts);
  return amounts[0] ?? 0;
};

export const computeCustomRemainder = (totalAmount: number, customAmount: number, roundAmounts = MONEY_DECIMALS === 0): number => {
  return clampToMoney(totalAmount - customAmount, roundAmounts);
};

export const isCustomSplitValid = (totalAmount: number, customAmount: number, roundAmounts = MONEY_DECIMALS === 0): boolean => {
  return customAmount > 0 && customAmount < totalAmount && (!roundAmounts || Number.isInteger(customAmount));
};
